import React from 'react';
export class TaskTableUI extends React.Component {
    constructor(props) {
        super(props);

        this.onViewClick = this.onViewClick.bind(this);
        this.onPrizeClick = this.onPrizeClick.bind(this);
        this.onGhoreClick = this.onGhoreClick.bind(this);
    }
    onViewClick(e) {
        //   console.log("view click");
        if (typeof this.props.onViewClick === "function") {
            this.props.onViewClick(e);

        }
    }


    onPrizeClick(e) {

        //     console.log("prize click");
        if (typeof this.props.onPrizeClick === "function") {
            this.props.onPrizeClick(e);
        }
    }


    onGhoreClick(e) {

        //     console.log("prize click");
        if (typeof this.props.onGhoreClick === "function") {
            this.props.onGhoreClick(e);
        }
    }


    render() {

        if (this.props.data != null && this.props.data.length > 0) {
            var Rows = this.props.data.map(
                (data) =>

                    <tr key={data.task.id}>
                        <td >
                            {data.task.reportName}
                        </td>
                        <td>
                            {data.stateStr}
                        </td>    
                        <td>
                            {data.persianInsertDate}
                        </td>
                        <td>
                            {data.persianStartDate}
                        </td>     
                        <td>
                            {data.persianEndDate}
                        </td>

                        <td>
                            {data.task.totalRow}
                        </td>
                        <td>
                            {data.task.currentRow}
                        </td>
                        <td>
                            {data.percent}
                        </td>

                        <td>                     
                            {data.fileLink===null? "" :<a href={data.fileLink} target="_blank" >دانلود</a> }
                        </td>
                        
                     
                                  

                    </tr>



            );
        }
        else {
            Rows = <tr><td colSpan="9">سطری وجود ندارد</td></tr>;
        }

        return (
            <div className="col-lg-12">
                <div className="">

                    <div className="table-responsive ">
                        <table className="table  table-striped text-center">
                            <thead>
                                <tr>                             
                                    <th >نام گزارش</th>
                                    <th>وضعیت</th>
                                    <th>تاریخ درخواست</th>
                                    <th>تاریخ شروع</th>
                                    <th>تاریخ پایان</th>
                                    <th> کل ردیف ها</th>
                                    <th>ردیف فعلی</th>
                                    <th>میزان پیشروی</th>
                                    <th>خروجی</th>    
                                </tr>

                            </thead>
                            <tbody>
                                {Rows}
                            </tbody>
                        </table>
                    </div>

                </div>

            </div>
        );

    }
}
/*
function printPrice(x) {


    // console.log("x:" + x);
    if (typeof (x) == "undefined")
        return "";

    if (x == null || x === "")
        return "";

    x = parseInt(x);

    return MytoLocaleString(x);
}

function MytoLocaleString(s) {

    var s1 = s.toLocaleString();
    var p = new Number(Math.floor(s) + 0.1);    // similar value but decimal
    var p1 = p.toLocaleString();
    var index;
    var point;
    for (index = p1.length - 1; index > 0; index--) { // find decimal point in dummy
        point = p1.charAt(index);
        if (point < '0' || point > '9')
            break;
    }
    if (index > 0) {
        index = s1.lastIndexOf(point);          // find last point in string
        if (index > 0)
            s1 = s1.slice(0, index);            // truncate decimal part

        return s1;
    }
    return "";
}
*/


// WEBPACK FOOTER //
// ./src/tables/task/TaskTableUI.js